import _ from 'lodash';

export function resolveTriggerLocksByIds(lockIds, pcuLockObjects, catalogLocks) {
  const pcuLocks = pcuLockObjects || [];
  const catalog = catalogLocks || [];
  return _.map(lockIds || [], (id) => {
    const fromPcu = _.find(pcuLocks, lock => lock.id === id || String(lock.id) === String(id));
    if (fromPcu && fromPcu.name) {
      return { id: fromPcu.id, name: fromPcu.name };
    }
    const fromCatalog = _.find(catalog, lock => lock.id === id || String(lock.id) === String(id));
    if (fromCatalog && fromCatalog.name) {
      return { id: fromCatalog.id, name: fromCatalog.name };
    }
    return { id, name: String(id) };
  });
}
